import { CircularProgress, Button, useTheme } from '@mui/material';
import { getStyled } from './styles';

const ButtonWithSpinner = ({ loading, children, ...rest }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  return (
    <Button style={classes.button} disabled={loading} {...rest}>
      {children}
      {loading && <CircularProgress size={24} style={classes.buttonProgress} />}
    </Button>
  );
};

export default ButtonWithSpinner;
